/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/

import { Injectable, NgZone, inject } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TenantInactivityService {
  private router = inject(Router);
  private ngZone = inject(NgZone);

  private timer: any;
  private readonly visibleTimeout = 30 * 60 * 1000; // 30 minutes on screen
  private readonly hiddenTimeout = 5 * 60 * 1000; // 5 minutes in background
  public onTimeout = new Subject<Date>();
  private startDate = new Date();
  private fired = false;

  constructor() {

    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.resetTimer();
      }
    });
    document.addEventListener('visibilitychange', () => {
        this.resetTimer();
    });    

    // Reset timer on user activity
    ['click', 'keypress', 'scroll', 'touchstart'].forEach(event => {
      window.addEventListener(event, () => this.resetTimer());
    });

    this.startTimer();
  }

  private startTimer() {
    const timeout = document.hidden ? this.hiddenTimeout : this.visibleTimeout
    this.startDate = new Date()
    this.ngZone.runOutsideAngular(() => {
      this.timer = setTimeout(() => this.triggerTimeout(), timeout);
    });
  }

  public resetTimer() {
    clearTimeout(this.timer);
    this.startTimer();
  }
  public acknowledgeTimeout() {
    // Events can queue in background, need to explicitly clear fired flag
    // otherwise we get repeated messages on screen
    this.fired = false;
  }

  private triggerTimeout() {
    this.ngZone.run(() => {
        if (!this.fired) {
            this.fired = true;
            this.onTimeout.next(this.startDate);
        }      
    });
  }
}
